import { useQuery, useQueryClient } from "@tanstack/react-query";

import { axiosInstance } from "../lib/axios";

export const USER_QUERY_KEY = ["user"] as const;

export type UserResponseType = {
  trial_expires_at?: number;
  branding?: string;
  results: {
    username: string;
    email_id: string;
    industry: string;
    profession: string;
    whatsapp_number: string;
    public_uuid: string;
  };
};

export const useFetchUserInfo = () => {
  return useQuery({
    queryKey: USER_QUERY_KEY,
    queryFn: () => axiosInstance.get<UserResponseType>("/user"),
    select: (data) => {
      return {
        ...data.data.results,
        trial_expires_at: data.data.trial_expires_at,
        branding: data.data.branding,
      };
    },
  });
};

export const useInvalidateUserData = () => {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: USER_QUERY_KEY });
};
